/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { PlatformAppService } from './services/platform-app.service';
import { PlatformChartService } from './services/platform-chart.service';
import { PlatformChartGroupService } from './services/platform-chart-group.service';
import { PlatformChartRelationService } from './services/platform-chart-relation.service';
import { PlatformDeviceService } from './services/platform-device.service';
import { PlatformEphemerisService } from './services/platform-ephemeris.service';
import { PlatformFeedbackService } from './services/platform-feedback.service';
import { PlatformGeocodingService } from './services/platform-geocoding.service';
import { PlatformHumanDesignService } from './services/platform-human-design.service';
import { PlatformIChingService } from './services/platform-i-ching.service';
import { PlatformLineTextReviewService } from './services/platform-line-text-review.service';
import { PlatformNavigationItemService } from './services/platform-navigation-item.service';
import { PlatformPlatformService } from './services/platform-platform.service';
import { PlatformPlatformModeService } from './services/platform-platform-mode.service';
import { PlatformPrintService } from './services/platform-print.service';
import { PlatformPublicService } from './services/platform-public.service';
import { PlatformSystemStatusService } from './services/platform-system-status.service';
import { PlatformUserAccountService } from './services/platform-user-account.service';
import { PlatformUserDataService } from './services/platform-user-data.service';
import { PlatformUserGroupService } from './services/platform-user-group.service';
import { PlatformUserPresenceService } from './services/platform-user-presence.service';
import { PlatformAnnouncementService } from './services/platform-announcement.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    PlatformAppService,
    PlatformChartService,
    PlatformChartGroupService,
    PlatformChartRelationService,
    PlatformDeviceService,
    PlatformEphemerisService,
    PlatformFeedbackService,
    PlatformGeocodingService,
    PlatformHumanDesignService,
    PlatformIChingService,
    PlatformLineTextReviewService,
    PlatformNavigationItemService,
    PlatformPlatformService,
    PlatformPlatformModeService,
    PlatformPrintService,
    PlatformPublicService,
    PlatformSystemStatusService,
    PlatformUserAccountService,
    PlatformUserDataService,
    PlatformUserGroupService,
    PlatformUserPresenceService,
    PlatformAnnouncementService,
    ApiConfiguration
  ],
})
export class PlatformApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<PlatformApiModule> {
    return {
      ngModule: PlatformApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: PlatformApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('PlatformApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
